import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import MAIN_PATHS from "../../../../mainPaths";
import { USER_FIELDS } from "../fields";
import { IRequestsPasswordUserFilter, IUsersFilter } from "../type";
import CONFIG from "../../../../../../general/constants/config";
import COMMON_FIELDS from "../../../../../../general/constants/commonFields";

export const pageSize = 20;

export const initialUsersFilterState: IUsersFilter = {
	[USER_FIELDS.TEXT]: undefined,
	[USER_FIELDS.DIVISION_ID]: undefined,
	[USER_FIELDS.MANAGER_ID]: undefined,
	[USER_FIELDS.STATUS]: undefined,
	[USER_FIELDS.PAGE_N]: undefined,
	[USER_FIELDS.PAGE_SIZE]: CONFIG.DEFAULT_GET_SIZE_ITEM_PAGE,
	[COMMON_FIELDS.SORT_BY]: undefined,
};

export const usersFilterSlice = createSlice({
	name: `${MAIN_PATHS.USERS_FILTER}Container`,
	initialState: initialUsersFilterState,
	reducers: {
		setFilters(state, action: PayloadAction<IUsersFilter>) {
			return {
				...state,
				...action.payload,
			};
		},
	},
});

export const usersFilterActions = usersFilterSlice.actions;
export const usersFilterReducer = usersFilterSlice.reducer;

export const initialUsersRequestPasswordFilterState: IRequestsPasswordUserFilter =
	{
		[USER_FIELDS.TEXT]: undefined,
		[USER_FIELDS.DIVISION_ID]: undefined,
		[USER_FIELDS.MANAGER_ID]: undefined,
		[USER_FIELDS.IS_DONE]: undefined,
		[USER_FIELDS.PAGE_N]: undefined,
		[USER_FIELDS.PAGE_SIZE]: CONFIG.DEFAULT_GET_SIZE_ITEM_PAGE,
		[COMMON_FIELDS.SORT_BY]: undefined,
	};

export const usersRequestPasswordFilterSlices = createSlice({
	name: `${MAIN_PATHS.USERS_REQUESTS_PASSWORD_FILTER}Container`,
	initialState: initialUsersRequestPasswordFilterState,
	reducers: {
		setFilters(state, action: PayloadAction<IRequestsPasswordUserFilter>) {
			return {
				...state,
				...action.payload,
			};
		},
	},
});

export const usersRequestPasswordFilterActions =
	usersRequestPasswordFilterSlices.actions;
export const usersRequestPasswordFilterReducer =
	usersRequestPasswordFilterSlices.reducer;
